import {AbstractControl} from "@angular/forms";

export function maxPassangersValidator(control: AbstractControl) {
  if (!((control.get('adults').value + control.get('kids').value + control.get('infants').value) > 0 && control.get('infants').value <= control.get('adults').value)) {
    return {maxPassangersInvalid: true};
  }
  return null;
}
